const appColors = {
  primary: "#007AFF",
  primaryDark: "#0A84FF",
  bggray: "#f4f4f4",
  bgDark: "#000000",
  bgDarkGray: "#1A1A1A",
  lightBlue: "#EAF3FF",
  textColor: "#121826",
  textColor2: "#8A8A8E",
  textColor3: "#C4C4C6",
  textColor4: "#DCDCDD",
  textDark: "#F2F2F2",
  textDark2: "#8D8D93",
  textDark3: "#47474A",
  textDark4: "#2B2B2C",
  black: "#000",
  white: "#fff",
  red: "#FF453A",
  yellow: "#FFCC00",
  orange: "#FF9500",
  green: "#34C759",
  mint: "#00C7BE",
  teel: "#30B0C7",
  gray: "#6e6d7a",
  deepGray: "#E6E6E6",
  lightGray: "#E9E9E9",
  borderGray: "#E2E2E2",
  borderDark: "#404043",
  shadow: "#E3E3E3",
};

export default appColors;
